<template>
    <div class="com-aonaer-admin-cus-detail-page-container">
        <!-- 左侧信息栏 -->
        <aside class="com-aonaer-admin-cus-detail-sidebar">
            <div class="com-aonaer-admin-cus-detail-avatar-box">
                <div class="com-aonaer-admin-cus-detail-avatar">{{ getFirstTwoCharsUppercase(customerInfo?.name) }}
                </div>
                <h2>{{ customerInfo?.name }}</h2>
                <span class="com-aonaer-admin-cus-detail-customer-grade">{{ ['A级客户', 'B级客户', 'C级客户', 'D级客户',
                    'E级客户'][customerInfo.rating || 0] }}</span>
            </div>

            <div class="com-aonaer-admin-cus-detail-sidebar-info-group">
                <h3>核心信息</h3>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">客户编号</span>
                    <span class="com-aonaer-admin-cus-detail-value">AONAERWM{{ customerInfo?.id }}</span>
                </div>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">所属地区</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.area }}</span>
                </div>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">合作年限</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ formatTimeAgoFuc(customerInfo?.ctime) }}</span>
                </div>
            </div>

            <div class="com-aonaer-admin-cus-detail-sidebar-info-group">
                <h3>联系方式</h3>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">电话</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.phone }}</span>
                </div>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">邮箱</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.email }}</span>
                </div>
            </div>

            <div class="com-aonaer-admin-cus-detail-sidebar-info-group" v-if="customerInfo?.account != null">
                <h3>负责销售</h3>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">销售</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.account?.nickname }}</span>
                </div>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">电话</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.account?.phone }}</span>
                </div>
                <div class="com-aonaer-admin-cus-detail-sidebar-info-item">
                    <span class="com-aonaer-admin-cus-detail-label">邮箱</span>
                    <span class="com-aonaer-admin-cus-detail-value">{{ customerInfo?.account?.email }}</span>
                </div>
            </div>

            <div class="com-aonaer-admin-cus-detail-sidebar-actions">
                <button v-if="customerInfo?.account == null"
                    class="com-aonaer-admin-cus-detail-btn com-aonaer-admin-cus-detail-btn-main"
                    @click="nowId2 = customerInfo.id; fpVisible = true;">
                    分配销售人员
                </button>
                <button class="com-aonaer-admin-cus-detail-btn com-aonaer-admin-cus-detail-btn-main"
                    @click="handleEdit">
                    编辑客户信息
                </button>
                <button class="com-aonaer-admin-cus-detail-btn com-aonaer-admin-cus-detail-btn-secondary"
                    @click="jumpToShop(customerInfo)">
                    录入采购询盘
                </button>
            </div>
        </aside>

        <!-- 右侧内容区 -->
        <main class="com-aonaer-admin-cus-detail-main-content">
            <div class="com-aonaer-admin-cus-detail-content-header">
                <h1>客户详情</h1>
                <a href="#" class="com-aonaer-admin-cus-detail-back-btn" @click.prevent="jumpToPage('客户管理', {}, {})">
                    ← 返回客户列表
                </a>
            </div>

            <!-- 基础信息模块 -->
            <section class="com-aonaer-admin-cus-detail-detail-section">
                <h3>基础信息</h3>
                <table class="com-aonaer-admin-cus-detail-detail-table">
                    <tr>
                        <th>公司全称</th>
                        <td>{{ customerInfo?.com || '无' }}</td>
                    </tr>
                    <tr>
                        <th>国家/地区</th>
                        <td>{{ customerInfo?.country || '无' }}</td>
                    </tr>
                    <tr>
                        <th>公司地址</th>
                        <td>{{ customerInfo?.area || '无' }}</td>
                    </tr>
                    <tr>
                        <th>宗教信息</th>
                        <td>{{ customerInfo?.religion || '无' }}</td>
                    </tr>
                    <tr>
                        <th>客户来源</th>
                        <td>{{ ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通',
                            '其他来源'][customerInfo.srce] }}</td>
                    </tr>
                </table>
            </section>

            <!-- 合作信息模块 -->
            <section class="com-aonaer-admin-cus-detail-detail-section">
                <h3>合作信息</h3>
                <table class="com-aonaer-admin-cus-detail-detail-table">
                    <tr>
                        <th>合作次数</th>
                        <td>{{ customerInfo?.data?.length || 0 }}</td>
                    </tr>
                    <tr>
                        <th>首次合作时间</th>
                        <td>{{ (customerInfo?.data?.length > 0 || customerInfo?.data != null) ?
                            initTime(customerInfo?.data[0]?.ctime) : '无' }}</td>
                    </tr>
                    <tr>
                        <th>最近合作时间</th>
                        <td>{{ (customerInfo?.data?.length > 0 || customerInfo?.data != null) ?
                            initTime(customerInfo?.data[customerInfo?.data?.length - 1]?.ctime) : '无' }}</td>
                    </tr>
                    <tr>
                        <th>订单数量</th>
                        <td>{{ customerInfo?.data?.length || 0 }}笔</td>
                    </tr>
                </table>
            </section>

            <!-- 其他信息模块 -->
            <section class="com-aonaer-admin-cus-detail-detail-section"
                v-show="customerInfo?.sx != null && customerInfo?.sx?.length > 0">
                <h3>其他信息</h3>
                <table class="com-aonaer-admin-cus-detail-detail-table">
                    <tr v-for="(item, index) in customerInfo?.sx" :key="index">
                        <th>{{ item.lb }}</th>
                        <td v-if="item.type == 0">{{ item.vl || '无' }}</td>
                        <td v-else-if="item.type == 1">
                            <MyUpload v-model="item.vl" :limit="10" size="100px" :disabled="true" :down="true"
                                :del="false">
                            </MyUpload>
                        </td>
                        <td v-else>{{ initTime(item.vl) || '无' }}</td>
                    </tr>
                </table>
            </section>

            <!-- 订单信息模块 -->
            <section class="com-aonaer-admin-cus-detail-detail-section" v-for="(nowOrder, index) in customerInfo?.data"
                :key="index">
                <h3>订单信息<span
                        style="position: relative;float: right;margin: auto;margin-right: 0;top: 0px;right: 0px;cursor: pointer;"
                        @click="jumpToOrder(nowOrder)">订单详情
                        ></span></h3>
                <div class="com-aonaer-admin-cus-detail-notes-box">
                    <div class="com-codics-hbb-order-admin-timeline-timeline-wrapper"
                        style="margin-top: 90px !important;">
                        <button
                            class="com-codics-hbb-order-admin-timeline-slide-btn com-codics-hbb-order-admin-timeline-prev-btn"
                            @click="handlePrevClick(index)">
                            <svg viewBox="0 0 24 24">
                                <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" />
                            </svg>
                        </button>

                        <!-- 时间线容器 -->
                        <div class="com-codics-hbb-order-admin-timeline-timeline-container"
                            :ref="el => timelineContainers[index] = el">
                            <!-- 循环渲染时间线节点 -->
                            <div v-for="(node, nodeIndex) in calcOrder(nowOrder)" :key="nodeIndex" :class="[
                                'com-codics-hbb-order-admin-timeline-timeline-node',
                                node.status === 'completed' ? 'com-codics-hbb-order-admin-timeline-completed' : '',
                                node.status === 'current' ? 'com-codics-hbb-order-admin-timeline-current' : ''
                            ]">
                                <div class="com-codics-hbb-order-admin-timeline-node-box">
                                    <span class="com-codics-hbb-order-admin-timeline-node-number">{{ nodeIndex + 1
                                    }}</span>
                                </div>
                                <div class="com-codics-hbb-order-admin-timeline-node-time">{{ initTime(node.time) }}
                                </div>
                                <div class="com-codics-hbb-order-admin-timeline-node-title">{{ node.title }}</div>
                                <div class="com-codics-hbb-order-admin-timeline-node-message">
                                    <div class="com-codics-hbb-order-admin-timeline-message-list">

                                        <div class="com-codics-hbb-order-admin-timeline-message-list-empty"
                                            v-if="node.messages.length === 0">
                                            暂无消息
                                        </div>
                                        <!-- 循环渲染单条消息 -->
                                        <div class="com-codics-hbb-order-admin-timeline-single-message"
                                            v-for="(msg, msgIndex) in node.messages" :key="msgIndex">
                                            <div class="com-codics-hbb-order-admin-timeline-single-message-title">{{
                                                msg.title
                                                }}</div>
                                            <div class="com-codics-hbb-order-admin-timeline-text-attachment"
                                                v-html="msg.mess">
                                            </div>
                                            <!-- 附件区域 -->
                                            <div class="com-codics-hbb-order-admin-timeline-attachment-container"
                                                v-if="msg.attach && msg.attach.split(',').length > 0">
                                                <div class="com-codics-hbb-order-admin-timeline-attachment-item"
                                                    v-for="(attach, attachIndex) in (msg.attach == '' ? [] : msg.attach.split(','))"
                                                    :key="attachIndex">
                                                    <!-- 图片附件：预览 -->
                                                    <img v-if="isImageFile(attach)"
                                                        :src="`https://cdn.bosscaigou.com/${attach}`" :alt="attach"
                                                        class="com-codics-hbb-order-admin-timeline-attachment-img"
                                                        @click="openImagePreview(`https://cdn.bosscaigou.com/${attach}`)" />
                                                    <!-- 非图片附件：下载 -->
                                                    <a v-else href="javascript:;"
                                                        class="com-codics-hbb-order-admin-timeline-attachment-file"
                                                        @click="downloadFile(`https://cdn.bosscaigou.com/${attach}`, `https://cdn.bosscaigou.com/${attach}`)">
                                                        <svg viewBox="0 0 24 24"
                                                            class="com-codics-hbb-order-admin-timeline-download-icon">
                                                            <path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" />
                                                        </svg>
                                                        <span class="com-codics-hbb-order-admin-timeline-file-name">{{
                                                            attach.split('/').pop() }}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="com-codics-hbb-order-admin-timeline-add iconfont"
                                            @click="jumpToOrder(nowOrder)">
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            class="com-codics-hbb-order-admin-timeline-slide-btn com-codics-hbb-order-admin-timeline-next-btn"
                            @click="handleNextClick(index)">
                            <svg viewBox="0 0 24 24">
                                <path d="M10,6L8.59,7.41L13.17,12L8.59,16.59L10,18L16,12L10,6Z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </section>
        </main>

        <!-- 分配销售弹窗 -->
        <MyDialog :visible.sync="fpVisible" title="分配销售" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="负责销售" required>
                    <el-select style="width:100%;" size="small" v-model="nowXs" clearable filterable remote
                        reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading">
                        <el-option v-for="(item, index) in userData" :key="index"
                            :label="`${item.nickname}(${item.account})`" :value="item.id">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="fpXsFuc">确认分配</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fpVisible = false;">取消分配</el-button>
            </div>
        </MyDialog>

        <!-- 编辑客户信息抽屉 -->
        <el-drawer title="修改客户信息" :visible.sync="cusDrawer" :direction="'btt'" size="100%">
            <button class="com-aonaer-admin-cusinfo-add-custom-field-btn" @click="openCustomFieldModal">
                添加自定义字段
            </button>
            <h2 class="com-aonaer-admin-cusinfo-add-form-group-title">基础信息</h2>
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="客户名称" required>
                    <el-input v-model="updateForm.name" placeholder="请输入客户名称" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="联系方式">
                    <el-input v-model="updateForm.phone" placeholder="请输入客户联系方式" maxLength="11" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);" label="邮箱">
                    <el-input v-model="updateForm.email" placeholder="请输入客户邮箱" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">公司信息</h2>
                <MyFormItem style="width:calc(50% - 7.5px);" label="公司名称">
                    <el-input v-model="updateForm.com" placeholder="请输入客户所属公司" style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属国家" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-cascader style="width:100%;" :props="{ checkStrictly: true }" filterable :options="areaOptions"
                        v-model="updateForm.country" clearable>
                    </el-cascader>
                </MyFormItem>
                <MyFormItem label="宗教信息" style="width:calc(50% - 7.5px);">
                    <el-input v-model="updateForm.religion" placeholder="请输入客户宗教信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户地址" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-input v-model="updateForm.area" placeholder="请输入客户地址信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" style="margin-top: 20px;">其他信息</h2>
                <MyFormItem label="客户来源" style="width:calc(50% - 7.5px);" required>
                    <el-select v-model="updateForm.srce" style="width:100%;" filterable placeholder="请选择客户来源">
                        <el-option v-for="(item, index) in [
                            { label: '阿里巴巴', value: 0 },
                            { label: '中国制造', value: 1 },
                            { label: '独立站', value: 2 },
                            { label: '公司展会', value: 3 },
                            { label: '集团客户', value: 4 },
                            { label: '亚马逊', value: 5 },
                            { label: '脸书', value: 6 },
                            { label: '广交会', value: 7 },
                            { label: '环球资源', value: 8 },
                            { label: '社交媒体', value: 9 },
                            { label: '速卖通', value: 10 },
                            { label: '其他来源', value: 11 }
                        ]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="客户评级" style="width:calc(50% - 7.5px);margin-left: 15px;" required>
                    <el-select v-model="updateForm.rating" style="width:100%;" filterable placeholder="请选择客户评级">
                        <el-option v-for="(item, index) in ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户']" :key="index"
                            :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <h2 class="com-aonaer-admin-cusinfo-add-form-group-title" v-if="customFields?.length > 0"
                    style="margin-top: 20px;">自定义信息</h2>
                <MyFormItem v-for="(field, index) in customFields" :key="index" style="width:calc(50% - 7.5px);"
                    :style="{ 'margin-left': index % 2 == 0 ? '0px' : '15px' }" :label="field.lb">
                    <el-input v-if="field.type === 0" v-model="field.vl" :placeholder="`请输入${field.vl}`" disabled
                        style="width:100%;" clearable></el-input>
                    <MyUpload v-if="field.type === 1" v-model="field.vl" :limit="10" size="100px" :del="false" disabled>
                    </MyUpload>
                    <el-date-picker v-if="field.type === 2" v-model="field.vl" style="width:100%" type="datetime"
                        disabled placeholder="选择日期时间">
                    </el-date-picker>
                    <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                        icon-color="red" title="确定删除当前信息吗？" @confirm="deleteSxFuc(field)">
                        <div class="com-aonaer-admin-cusinfo-add-form-item-btn iconfont" slot="reference">
                            &#xEC2A;
                        </div>
                    </el-popconfirm>
                </MyFormItem>
            </MyForm>
            <div class="com-aonaer-admin-cusinfo-add-btn-group">
                <button type="button"
                    class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
                    @click="cusDrawer = false">取消</button>
                <button type="button" class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
                    @click="updateCusInfoFuc()">修改</button>
            </div>
        </el-drawer>

        <!-- 自定义字段弹窗 -->
        <div class="com-aonaer-admin-cusinfo-add-modal" style="z-index: 999999999;" v-if="isModalOpen"
            @click="isModalOpen = false;">
            <div class="com-aonaer-admin-cusinfo-add-modal-content" @click.stop>
                <h3 class="com-aonaer-admin-cusinfo-add-modal-title">添加自定义字段</h3>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">字段名称 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <input type="text" class="com-aonaer-admin-cusinfo-add-form-control"
                        style="width: calc(100% - 30px);"
                        :class="{ 'com-aonaer-admin-cusinfo-add-error': !!modalError }" v-model="modalFieldName"
                        placeholder="请输入字段名称">
                    <div class="com-aonaer-admin-cusinfo-add-error-message" v-if="modalError">{{ modalError }}</div>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">数据类型 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <select class="com-aonaer-admin-cusinfo-add-form-control" v-model="modalFieldType">
                        <option value="string">字符串（文本输入）</option>
                        <option value="file">文件上传</option>
                        <option value="date">日期</option>
                    </select>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-form-item">
                    <label class="com-aonaer-admin-cusinfo-add-form-label">数据类型 <span
                            class="com-aonaer-admin-cusinfo-add-required">*</span></label>
                    <el-input v-if="modalFieldType === 'string'" v-model="modalFieldStringValue"
                        :placeholder="`请输入${modalFieldName}`" style="width:100%;" clearable
                        @input="updateCusInfoSxFuc(field)"></el-input>
                    <MyUpload v-if="modalFieldType === 'file'" v-model="modalFieldFileValue" :limit="10" size="100px">
                    </MyUpload>
                    <el-date-picker v-if="modalFieldType === 'date'" v-model="modalFieldDateValue" style="width:100%"
                        type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
                <div class="com-aonaer-admin-cusinfo-add-modal-footer">
                    <button type="button"
                        class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-secondary"
                        @click="isModalOpen = false;">取消</button>
                    <button type="button"
                        class="com-aonaer-admin-cusinfo-add-btn com-aonaer-admin-cusinfo-add-btn-primary"
                        @click="confirmAddCustomField">确认添加</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MyDialog from '@/components/MyDialog';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import MyUpload from '@/components/MyUpload';
import { jumpTo, formatTimeAgo, initTime } from '@/utils/myutils';
import { infoCus, queryUsers, fpXs, cancelOrder, updateCusInfo, addCusInfoSx, deleteCusInfoSx } from '@/api';
import areaData from '@/../public/data/data2.json';
export default {
    name: 'ComAonaerAdminCusDetail',
    data() {
        return {
            areaOptions: areaData,
            cusDrawer: false,
            updateForm: {},
            customFields: [],
            modalFieldName: '',
            modalFieldType: '',
            modalFieldStringValue: '',
            modalFieldFileValue: [],
            modalFieldDateValue: '',
            modalError: '',
            isModalOpen: false,
            nowSid: null,
            nowId: null,
            nowId2: null,
            fpVisible: false,
            nowXs: null,
            loading: false,
            userData: [],
            customerInfo: {
                data: []
            },
            timelineContainers: [],
            wheelListeners: []
        }
    },
    methods: {
        async deleteSxFuc(field) {

            const loading = this.$loading({
                lock: true,
                text: '删除信息中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await deleteCusInfoSx({
                ids: [field.id]
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('信息删除成功！');
                this.customFields = this.customFields.filter(f => f.id !== field.id);
                this.refreshKey++;
            } else {
                this.$message.error('信息删除失败！');
            }

        },
        async updateCusInfoFuc() {
            if (this.updateForm.name == null || this.updateForm.name == '') {
                this.$message.error('请输入客户名称！');
                return;
            }
            if (this.updateForm.phone == null || this.updateForm.phone == '' || this.updateForm.phone.length != 11) {
                this.$message.error('客户联系方式未填写或格式不正确！');
                return;
            }
            if (this.updateForm.pid === null || this.updateForm.pid === '') {
                this.$message.error('请选择客户类型！');
                return;
            }
            if (this.updateForm.email !== null && this.updateForm.email !== '') {
                if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.updateForm.email)) {
                    this.$message.error('请输入正确的邮箱格式！');
                    return;
                }
            }
            if (this.updateForm.rating === null || this.updateForm.rating === '') {
                this.$message.error('请选择客户评级！');
                return;
            }
            if (this.updateForm.srce === null || this.updateForm.srce === '') {
                this.$message.error('请选择客户来源！');
                return;
            }
            this.updateForm.country && (this.updateForm.country = this.updateForm.country.join('/'));
            this.updateForm.sx = null;
            const loading = this.$loading({
                lock: true,
                text: '修改中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateCusInfo(this.updateForm);
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户修改成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        jumpToOrder(order) {
            jumpTo(this, '订单详情', { id: order.id }, {});
        },
        handleEdit() {
            this.updateForm = this.customerInfo;
            this.cusDrawer = true;
        },
        isImageFile(fileName) {
            const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
            const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
            return imageExts.includes(ext);
        },
        async confirmAddCustomField() {
            if (this.modalFieldName == null || this.modalFieldName == '') {
                this.$message.error('请输入信息名称！');
                return;
            }
            if (this.modalFieldType == null || this.modalFieldType == '') {
                this.$message.error('请选择信息类型！');
                return;
            }
            this.isModalOpen = false;
            const loading = this.$loading({
                lock: true,
                text: '添加信息中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addCusInfoSx({
                sid: this.nowSid,
                lb: this.modalFieldName,
                type: this.modalFieldType == 'string' ? 0 : (this.modalFieldType == 'file' ? 1 : 2),
                vl: this.modalFieldType == 'string' ? this.modalFieldStringValue : (this.modalFieldType == 'file' ? this.modalFieldFileValue.join(',') : this.modalFieldDateValue)
            });
            loading.close();
            console.log(data.code);
            if (data.code == 200) {
                this.$message.success('信息添加成功！');
                if (this.modalFieldType == 'file') {
                    data.data.vl = data.data.vl.split(',') || [];
                }
                this.customFields.push(data.data);
            } else {
                this.$message.error('信息添加失败！');
            }
        },
        calcOrder(item) {
            console.log('11111', item.stateEight);
            const timelineNodes = [
                {
                    status: item.state >= 0 ? 'completed' : 'current',
                    time: item.ctime || '无信息',
                    title: "添加询盘",
                    messages: [...item.stateOne]
                },
                {
                    status: item.state >= 1 ? 'completed' : 'current',
                    time: item.stateTwo[0]?.ctime || '无信息',
                    title: "询盘评级",
                    messages: [...item.stateTwo]
                },
                {
                    status: item.state >= 2 ? 'completed' : 'current',
                    time: item.stateThree[0]?.ctime || '无信息',
                    title: "初始报价",
                    messages: [...item.stateThree]
                },
                {
                    status: item.state >= 3 ? 'completed' : 'current',
                    time: item.stateFour[0]?.ctime || '无信息',
                    title: "终极报价",
                    messages: [...item.stateFour]
                },
                {
                    status: item.state >= 4 ? 'completed' : 'current',
                    time: item.stateFive[0]?.ctime || '无信息',
                    title: "生成订单",
                    messages: [...item.stateFive]
                },
                {
                    status: item.state >= 5 ? 'completed' : 'current',
                    time: item.stateSix[0]?.ctime || '无信息',
                    title: "订单支付",
                    messages: [...item.stateSix]
                },
                {
                    status: item.state >= 6 ? 'completed' : 'current',
                    time: item.stateSeven[0]?.ctime || '无信息',
                    title: "订单发货",
                    messages: [...item.stateSeven]
                },
                {
                    status: item.state >= 7 ? 'completed' : 'current',
                    time: item.stateEight?.length > 0 ? initTime(item.stateEight[0]?.ctime) : '无信息',
                    title: "订单完成",
                    messages: [...item.stateEight]
                }
            ];
            return (item.state == 8 ? [...timelineNodes.filter(node => node.messages.length > 0), {
                status: 'completed',
                time: item.stateEight?.length > 0 ? initTime(item.stateEight[0]?.ctime) : '无信息',
                title: '订单已取消',
                messages: [...item.stateNine]
            }] : timelineNodes)
        },
        handleEdit() {
            const customer = this.customerInfo;
            this.updateForm = customer;
            this.updateForm.country = customer.country.split('/') || [];
            this.updateForm.srce = Number(customer.srce || 0);
            this.customFields = customer.sx || [];
            this.nowSid = customer.id;
            this.customFields.forEach(field => {
                if (field.type === 1 && typeof field.vl === 'string') {
                    field.vl = field.vl.split(',') || [];
                }
            });
            this.cusDrawer = true;
        },
        openCustomFieldModal() {
            this.isModalOpen = true;
            this.modalFieldName = '';
            this.modalFieldType = 'string';
            this.modalError = '';
        },
        async fpXsFuc() {
            if (this.nowXs === null || this.nowXs === '') {
                this.$message.error('请选择销售！');
                return;
            }
            if (this.nowId2 === null || this.nowId2 === '') {
                this.$message.error('请选择客户！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await fpXs({
                id: this.nowId2,
                uid: this.nowXs
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户分配成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async queryUsersFuc(query) {
            if (query === '') {
                this.userData = [];
                return;
            }
            this.loading = true;
            const data = await queryUsers({
                key: query
            });
            this.loading = false;
            if (data.code == 200) {
                this.userData = data.data;
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        jumpToShop(row) {
            window.ceshiProduct = row;
            jumpTo(this, "产品商城", {}, { id: row.id });
        },
        initTime(time) {
            return initTime(time);
        },
        getFirstTwoCharsUppercase(str) {
            if (!str || typeof str !== 'string') {
                return '';
            }
            const result = str.slice(0, 1).toUpperCase();
            return result;
        },
        async infoCusFuc() {
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const res = await infoCus({
                id: this.$route.params.id
            });
            loading.close();
            if (res.code == 200) {
                this.customerInfo = res.data;
                this.customerInfo.data.forEach(item => {
                    item.stateOne = item.stateOne || [];
                    item.stateTwo = item.stateTwo || [];
                    item.stateThree = item.stateThree || [];
                    item.stateFour = item.stateFour || [];
                    item.stateFive = item.stateFive || [];
                    item.stateSix = item.stateSix || [];
                    item.stateSeven = item.stateSeven || [];
                    item.stateEight = item.stateEight || [];
                    item.stateNine = item.stateNine || [];

                    item.mess.forEach(msg => {
                        if (msg.state == 0) {
                            item.stateOne = item.stateOne || [];
                            item.stateOne.push(msg);
                        } else if (msg.state == 1) {
                            item.stateTwo = item.stateTwo || [];
                            item.stateTwo.push(msg);
                        } else if (msg.state == 2) {
                            item.stateThree = item.stateThree || [];
                            item.stateThree.push(msg);
                        } else if (msg.state == 3) {
                            item.stateFour = item.stateFour || [];
                            item.stateFour.push(msg);
                        } else if (msg.state == 4) {
                            item.stateFive = item.stateFive || [];
                            item.stateFive.push(msg);
                        } else if (msg.state == 5) {
                            item.stateSix = item.stateSix || [];
                            item.stateSix.push(msg);
                        } else if (msg.state == 6) {
                            item.stateSeven = item.stateSeven || [];
                            item.stateSeven.push(msg);
                        } else if (msg.state == 7) {
                            item.stateEight = item.stateEight || [];
                            item.stateEight.push(msg);
                        } else if (msg.state == 8) {
                            item.stateNine = item.stateNine || [];
                            item.stateNine.push(msg);
                        }
                    })
                })
                this.customerInfo.sx.forEach(item => {
                    if (item.type === 1) {
                        item.vl = item.vl.split(',');
                    }
                })

                this.$nextTick(() => {
                    this.initTimelineWheelEvent();
                });
            } else {
                this.$message.error(res.message || '获取客户详情失败');
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        handleBtnClick(action) {
            alert(`执行【${action}】操作`);
        },
        handleBackClick() {
            alert('返回客户列表页面');
        },
        formatTimeAgoFuc(time) {
            console.log(time);
            return formatTimeAgo(new Date(time));
        },
        initTimelineWheelEvent() {
            this.wheelListeners.forEach(({ el, handler }) => {
                el?.removeEventListener('wheel', handler);
            });
            this.wheelListeners = [];

            this.timelineContainers.forEach(el => {
                if (!el) return;
                const handler = (e) => {
                    e.preventDefault();
                    const scrollDistance = e.deltaY * 3;
                    el.scrollLeft += scrollDistance;
                };
                el.addEventListener('wheel', handler, { passive: false });
                this.wheelListeners.push({ el, handler });
            });
        },
        openImagePreview(url) {
            window.open(url, '_blank');
        },
        downloadFile(url, fileName) {
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName || '附件';
            a.click();
        },
        // 新增：左滑按钮点击事件
        handlePrevClick(index) {
            const container = this.timelineContainers[index];
            if (container) {
                // 每次向左平滑滚动400px，可根据实际节点宽度调整
                container.scrollBy({ left: -400, behavior: 'smooth' });
            }
        },
        // 新增：右滑按钮点击事件
        handleNextClick(index) {
            const container = this.timelineContainers[index];
            if (container) {
                // 每次向右平滑滚动400px，可根据实际节点宽度调整
                container.scrollBy({ left: 400, behavior: 'smooth' });
            }
        }
    },
    components: {
        MyUpload,
        MyDialog,
        MyForm,
        MyFormItem
    },
    mounted() {
        this.infoCusFuc();
    },
    beforeDestroy() {
        this.wheelListeners.forEach(({ el, handler }) => {
            el?.removeEventListener('wheel', handler);
        });
    }
}
</script>

<style>
/* 页面容器 */
.com-aonaer-admin-cus-detail-page-container {
    display: flex;
    min-height: 100vh;
}

/* 左侧信息栏 */
.com-aonaer-admin-cus-detail-sidebar {
    width: 320px;
    background-color: #f9f9f9;
    border-right: 1px solid #e5e5e5;
    padding: 30px 24px;
    position: sticky;
    top: 0;
    height: 100vh;
}

.com-aonaer-admin-cus-detail-avatar-box {
    text-align: center;
    margin-bottom: 24px;
}

.com-aonaer-admin-cus-detail-avatar {
    width: 100px;
    height: 100px;
    background-color: #ddd;
    border-radius: 8px;
    margin: 0 auto 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #888;
}

.com-aonaer-admin-cus-detail-sidebar h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 4px;
}

.com-aonaer-admin-cus-detail-customer-grade {
    font-size: 14px;
    color: #000;
    background-color: #e0e0e0;
    padding: 2px 8px;
    border-radius: 12px;
    display: inline-block;
    margin-bottom: 20px;
}

.com-aonaer-admin-cus-detail-sidebar-info-group {
    margin-bottom: 24px;
}

.com-aonaer-admin-cus-detail-sidebar-info-group h3 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e5e5;
}

.com-aonaer-admin-cus-detail-sidebar-info-item {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 14px;
}

.com-aonaer-admin-cus-detail-label {
    color: #666;
}

.com-aonaer-admin-cus-detail-value {
    color: #222;
    font-weight: 500;
    text-align: right;
}

.com-aonaer-admin-cus-detail-sidebar-actions {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.com-aonaer-admin-cus-detail-btn {
    padding: 10px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    transition: all 0.2s;
}

.com-aonaer-admin-cus-detail-btn-main {
    background-color: #000;
    color: #fff;
}

.com-aonaer-admin-cus-detail-btn-main:hover {
    background-color: #333;
}

.com-aonaer-admin-cus-detail-btn-secondary {
    background-color: #fff;
    color: #000;
    border: 1px solid #ddd;
}

.com-aonaer-admin-cus-detail-btn-secondary:hover {
    background-color: #f0f0f0;
}

/* 右侧内容区 */
.com-aonaer-admin-cus-detail-main-content {
    flex: 1;
    padding: 30px 40px;
    overflow-y: auto;
}

.com-aonaer-admin-cus-detail-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e5e5e5;
}

.com-aonaer-admin-cus-detail-content-header h1 {
    font-size: 24px;
    font-weight: 700;
}

.com-aonaer-admin-cus-detail-back-btn {
    color: #666;
    text-decoration: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.com-aonaer-admin-cus-detail-back-btn:hover {
    color: #000;
}

/* 详情模块 */
.com-aonaer-admin-cus-detail-detail-section {
    margin-bottom: 36px;
}

.com-aonaer-admin-cus-detail-detail-section h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.com-aonaer-admin-cus-detail-detail-section h3::before {
    content: "";
    display: block;
    width: 4px;
    height: 20px;
    background-color: #000;
}

/* 表格样式 */
.com-aonaer-admin-cus-detail-detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.com-aonaer-admin-cus-detail-detail-table th,
.com-aonaer-admin-cus-detail-detail-table td {
    padding: 12px 16px;
    border: 1px solid #eee;
}

.com-aonaer-admin-cus-detail-detail-table th {
    background-color: #f9f9f9;
    font-weight: 600;
    text-align: left;
    width: 200px;
}

.com-aonaer-admin-cus-detail-detail-table td {
    color: #333;
}

/* 备注文本域 */
.com-aonaer-admin-cus-detail-notes-box {
    width: 100%;
    padding: 16px;
    background-color: #f9f9f9;
    border: 1px solid #eee;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    min-height: 120px;
    white-space: pre-line;
}

/* 时间线容器横向滚动 */
.com-codics-hbb-order-admin-timeline-timeline-container {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-left: unset !important;
    padding-right: unset !important;
}

/* 响应式适配 */
@media (max-width: 992px) {
    .com-aonaer-admin-cus-detail-page-container {
        flex-direction: column;
    }

    .com-aonaer-admin-cus-detail-sidebar {
        width: 100%;
        height: auto;
        position: static;
        border-right: none;
        border-bottom: 1px solid #e5e5e5;
    }

    .com-aonaer-admin-cus-detail-main-content {
        padding: 20px;
    }
}

.com-aonaer-admin-cus-detail-page-container .el-drawer__body {
    padding: 0 20px !important;
}

.com-aonaer-admin-cus-detail-page-container .com-aonaer-admin-cus-detail-notes-box,
.com-aonaer-admin-cus-detail-page-container .com-codics-hbb-order-admin-timeline-timeline-wrapper {
    box-sizing: border-box !important;
}

.com-aonaer-admin-cus-detail-page-container .com-codics-hbb-order-admin-timeline-timeline-wrapper {
    padding: unset !important;
}
</style>